import React, { useCallback, useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import moment from "moment";
import "./NewMatchPage.scss";
import {
  Button,
  Checkbox,
  Collapse,
  Input,
  message,
  Select,
  Tag,
  Typography,
  Drawer,
  Modal
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { debounce } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotel } from "@fortawesome/free-solid-svg-icons";

import {
  DoubleRightOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  CopyOutlined,
  LoadingOutlined,
  CheckOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Resizable } from "react-resizable";
import NewGstinPage from "../AddNewGSTIN";
import { use } from "react";
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;



function validateGSTIN(gstin) {
  const gstinPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;
  return gstinPattern.test(gstin);
}

export default function NewMatchPage(props) {
  const [matchDocument, setMatchDocument] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [validatedHSN332Amount, setValidatedHSN332Amount] = useState("");
  const [validatedGSTAmount, setValidatedGSTAmount] = useState("");
  const [validatedInvoiceAmount, setValidatedInvoiceAmount] = useState("");
  const [clientGSTIN, setClientGSTIN] = useState("");
  const [clientWorkspace, setClientWorkspace] = useState("");
  const [clientEnteredGSTIN, setClientEnteredGSTIN] = useState("");
  const [hotelEnteredGSTIN, setHotelEnteredGSTIN] = useState("");
  const [hotelGSTIN, setHotelGSTIN] = useState("");
  const [hotelName, setHotelName] = useState("");
  const [enableHotelCreate, setEnableHotelCreate] = useState(false);
  const [enableClientGSTIN, setEnableClientGSTIN] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [selected2BMatch, setSelected2BMatch] = useState(null);
  const [selectedBookingMatch, setSelectedBookingMatch] = useState(null);
  const [selectedIssue, setSelectedIssue] = useState("");
  const [rowData, setRowData] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [clientLoading, setClientLoading] = useState(false);
  const [hotelLoading, setHotelLoading] = useState(false);
  const [width, setWidth] = useState(400);
  const { documentId } = useParams();
  const [totalCount, setTotalCount] = useState(0)
  const [currenntDoc, setCurrentDoc] = useState(0)
  const [validatedInvoiceDate, setValidatedInvoiceDate] = useState(null)
  const inputRefs = {
    "11": useRef(null),
    "12": useRef(null),
    "13": useRef(null),
    "14": useRef(null),
    "15": useRef(null),
    "16": useRef(null),
    "17": useRef(null),
    "18": useRef(null),
    "19": useRef(null),
  };

  console.log(documentId, "documentId")
  const [bookingRowData, setBookingRowData] = useState([]);
  const [amount996331, setAmount996331] = useState(0);
  const [amount996332, setAmount99632] = useState(0);
  const [amount996334, setAmount996334] = useState(0);
  const [amount99639, setAmount996339] = useState(0);
  const [amount996311, setAmount996311] = useState(0);
  const [invoiceNumber, setInvoiceNumber] = useState(0)
  const [isNonInvoice, setIsNonInvoice] = useState(false)
  const [workspaceStatusTag, setWorkspaceStatusTag] = useState("Validation Required")
  const [hotelStatusTag, setHotelStatusTag] = useState("Validation Required")
  const [parsedStatusTag, setParsedStatusTag] = useState("Validation Required")
  const [skipGSTIN, setSkipGSTIN] = useState(false);
  const [skipBookingGSTIN, setSkipBookingGSTIN] = useState(false)
  const [assetLink, setAssetLink] = useState("")
  const [document_id, setDocument_id] = useState("")

  const [filterType, setFilterType] = useState("All");
  const [filterValue, setFilterValue] = useState("");
  const [showMoreParsedData, setShowMoreParsedData] = useState(false);
  const [dynamicFieldValues, setDynamicFieldValues] = useState({});
  const [dynamicFieldInputValues, setDynamicFieldInputValues] = useState({}); // First input box values
  const [dynamicFieldOutputValues, setDynamicFieldOutputValues] = useState({}); // Second input box values (mandatory)
  const [clientList, setClientList] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedClientPan, setSelectedClientPan] = useState("");
  const [clientListLoading, setClientListLoading] = useState(false);
  const [currentFilterPanNumbers, setCurrentFilterPanNumbers] = useState([]);
  const [currentFilterGstinNumbers, setCurrentFilterGstinNumbers] = useState([]);




  const [isExpanded, setIsExpanded] = useState(false);


  const [pdfDimensions, setPdfDimensions] = useState({ width: '34%', height: '100%' });
  const [pdfIsResizing, setPdfIsResizing] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [noMatch, setNoMatch] = useState(false);
  const startResizing = (e) => {
    e.preventDefault();
    setPdfIsResizing(true);
  };

  const stopResizing = () => {
    if (pdfIsResizing) {
      setPdfIsResizing(false);
    }
  };

  const onResize = (e) => {
    if (pdfIsResizing) {
      const parentElement = e.currentTarget.parentElement;
      const parentWidth = parentElement.offsetWidth;
      const newWidthPixels = e.clientX - parentElement.getBoundingClientRect().left;

      const maxWidthPixels = parentWidth * 0.1;

      const finalWidth = newWidthPixels > 0 && newWidthPixels <= maxWidthPixels
        ? newWidthPixels : parseFloat(dimensions.width) / 100 * parentWidth;

      setPdfDimensions({
        width: `${(finalWidth / parentWidth) * 100}%`,
        height: dimensions.height, // Keep the existing height or calculate similarly if needed
      });
    }
  };

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth * 0.4,
    height: 800,
  });
  const { Option } = Select
  const navigate = useNavigate();
  const handleLeftArrowClick = () => {
    navigate("/outputTable");
  };



  const [isResizing, setIsResizing] = useState(false);

  const handleMouseDown = (e) => {
    e.preventDefault(); // Prevent default behavior
    setIsResizing(true);

    const startX = e.clientX;
    const startY = e.clientY;

    const startWidth = dimensions.width;
    const startHeight = dimensions.height;

    // Event listeners to resize on drag
    const handleMouseMove = (e) => {
      if (!isResizing) return;

      const newWidth = startWidth + (e.clientX - startX);
      const newHeight = startHeight + (e.clientY - startY);

      setDimensions({
        width: Math.max(newWidth, 100), // Minimum width: 100px
        height: Math.max(newHeight, 50), // Minimum height: 50px
      });
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    // Attach global event listeners for dragging
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // State to control Drawer visibility

  const openDrawer = () => {
    setIsDrawerOpen(true); // Open the Drawer
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false); // Close the Drawer
  };

  // useEffect(() => {
  //   fetchDocument();
  // }, []);
  useEffect(() => {
    if (documentId) {
      fetchDocumentWithId();
    } else {
      fetchDocument();
    }
  }, [documentId])

  // State to track validation errors for highlighting
  const [validationErrors, setValidationErrors] = useState({
    clientGSTIN: false,
    hotelName: false,
    hotelGSTIN: false,
    gstAmount: false,
    invoiceNumber: false,
    invoiceAmount: false,
    invoiceDate: false,
    showMoreFields: {}
  });

  // Helper function to check if a value is empty (considering 0, [], and "" as valid)
  const isEmptyValue = (value) => {
    if (value === null || value === undefined) return true;
    // Empty string "" is a valid value (if it exists in original document)
    if (typeof value === 'string' && value === "") return false; // "" is valid
    if (typeof value === 'string' && value.trim() === "" && value !== "") return true; // Whitespace-only strings are invalid
    if (typeof value === 'number' && value === 0) return false; // 0 is a valid value
    if (Array.isArray(value) && value.length === 0) return false; // Empty array [] is a valid value
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return true;
    return false;
  };

  // Function to check if all required fields are filled
  const validateAllFields = () => {
    const errors = {
      clientGSTIN: false,
      hotelName: false,
      hotelGSTIN: false,
      gstAmount: false,
      invoiceNumber: false,
      invoiceAmount: false,
      invoiceDate: false,
      showMoreFields: {}
    };

    // Validate Client Detail
    const isClientGSTINFilled = clientEnteredGSTIN && clientEnteredGSTIN.trim() !== "";
    errors.clientGSTIN = !isClientGSTINFilled;

    // Validate Hotel Detail
    const isHotelNameFilled = hotelName && hotelName.trim() !== "";
    const isHotelGSTINFilled = hotelGSTIN && hotelGSTIN.trim() !== "";
    errors.hotelName = !isHotelNameFilled;
    errors.hotelGSTIN = !isHotelGSTINFilled;

    // Validate Parsed data
    const isGSTAmountFilled = validatedGSTAmount !== null && validatedGSTAmount !== undefined && 
                              (validatedGSTAmount.toString().trim() !== "" || validatedGSTAmount === 0);
    const isInvoiceNumberFilled = invoiceNumber !== null && invoiceNumber !== undefined && 
                                   (invoiceNumber.toString().trim() !== "" || invoiceNumber === 0);
    const isInvoiceAmountFilled = validatedInvoiceAmount !== null && validatedInvoiceAmount !== undefined && 
                                  (validatedInvoiceAmount.toString().trim() !== "" || validatedInvoiceAmount === 0);
    const isInvoiceDateFilled = validatedInvoiceDate && validatedInvoiceDate.toString().trim() !== "";
    errors.gstAmount = !isGSTAmountFilled;
    errors.invoiceNumber = !isInvoiceNumberFilled;
    errors.invoiceAmount = !isInvoiceAmountFilled;
    errors.invoiceDate = !isInvoiceDateFilled;

    // Validate Show More fields (only fields that exist in original document)
    if (matchDocument) {
      const excludedFields = [
        'total_tax_amount',
        'invoice_number',
        'invoice_amount',
        'invoice_date',
        'guest_gstin',
        'hotel_gstin',
        'hotel_name'
      ];
      
      // Show More fields are optional - no validation errors
      // They are auto-populated but not required
    }

    setValidationErrors(errors);

    // Check if all fields are valid (Show More fields are optional, so don't check them)
    const hasErrors = errors.clientGSTIN || errors.hotelName || errors.hotelGSTIN ||
                     errors.gstAmount || errors.invoiceNumber || errors.invoiceAmount || 
                     errors.invoiceDate;
    
    return !hasErrors;
  };

  // Function to validate Client Detail section
  const validateClientDetail = () => {
    const isClientGSTINFilled = clientEnteredGSTIN && clientEnteredGSTIN.trim() !== "";
    setWorkspaceStatusTag(isClientGSTINFilled ? "Validated" : "Validation Required");
  };

  // Function to validate Hotel Detail section
  const validateHotelDetail = () => {
    const isHotelNameFilled = hotelName && hotelName.trim() !== "";
    const isHotelGSTINFilled = hotelGSTIN && hotelGSTIN.trim() !== "";
    const allFieldsFilled = isHotelNameFilled && isHotelGSTINFilled;
    setHotelStatusTag(allFieldsFilled ? "Validated" : "Validation Required");
  };

  // Function to validate Parsed data section
  const validateParsedData = () => {
    const isGSTAmountFilled = validatedGSTAmount !== null && validatedGSTAmount !== undefined && 
                              (validatedGSTAmount.toString().trim() !== "" || validatedGSTAmount === 0);
    const isInvoiceNumberFilled = invoiceNumber !== null && invoiceNumber !== undefined && 
                                   (invoiceNumber.toString().trim() !== "" || invoiceNumber === 0);
    const isInvoiceAmountFilled = validatedInvoiceAmount !== null && validatedInvoiceAmount !== undefined && 
                                  (validatedInvoiceAmount.toString().trim() !== "" || validatedInvoiceAmount === 0);
    const isInvoiceDateFilled = validatedInvoiceDate && validatedInvoiceDate.toString().trim() !== "";
    
    // Show More fields are optional - always considered filled
    // They are auto-populated but not required for validation
    const allShowMoreFieldsFilled = true;
    
    const allFieldsFilled = isGSTAmountFilled && isInvoiceNumberFilled && 
                           isInvoiceAmountFilled && isInvoiceDateFilled && allShowMoreFieldsFilled;
    setParsedStatusTag(allFieldsFilled ? "Validated" : "Validation Required");
  };

  // Track if save button should be disabled
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  // Update validation tags when relevant state changes
  useEffect(() => {
    validateClientDetail();
  }, [clientEnteredGSTIN]);

  useEffect(() => {
    validateHotelDetail();
  }, [hotelName, hotelGSTIN]);

  useEffect(() => {
    validateParsedData();
  }, [validatedGSTAmount, invoiceNumber, validatedInvoiceAmount, validatedInvoiceDate, dynamicFieldOutputValues, showMoreParsedData, matchDocument]);

  // Update save button state and validation errors whenever relevant state changes
  useEffect(() => {
    const isValid = validateAllFields();
    setIsSaveDisabled(!isValid);
  }, [clientEnteredGSTIN, hotelName, hotelGSTIN, validatedGSTAmount, invoiceNumber, validatedInvoiceAmount, validatedInvoiceDate, dynamicFieldOutputValues, matchDocument]);

  const fetchDocumentWithId = async () => {
    setLoading(true);
    const response = await axios.get(
      `https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document?documentId=${documentId}`
    );


    if (response.status) {
      setMatchDocument(response.data.data?.AI_parsed_data.parsed_data);
      setRowData(response.data.data?.two_b_matches);

    }
    setLoading(false);
  };


  const fetchDocument = async (filterParams = {}) => {
    setLoading(true);
    let url = `https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document`;
    // let url = `http://localhost:7002/api/fuzzy/match_document`;
    
    // Build query parameters if filter is applied
    if (filterParams.type && filterParams.type !== "All" && filterParams.value) {
      const params = new URLSearchParams();
      params.append(filterParams.type, filterParams.value);
      // Add PAN numbers if provided (for client_name filter)
      if (filterParams.pan_numbers && filterParams.pan_numbers.length > 0) {
        params.append('pan_numbers', filterParams.pan_numbers.join(','));
      }
      // Add GSTIN numbers if provided (for client_gstin or hotel_gstin filter)
      if (filterParams.gstin_numbers && filterParams.gstin_numbers.length > 0) {
        params.append('gstin_numbers', filterParams.gstin_numbers.join(','));
      }
      url += `?${params.toString()}`;
    }
    // Fetch the next document without priority
    const response = await axios.get(url);
    console.log(response, "response in fetchDocument")
    if (response.status) {
      setMatchDocument(response?.data?.data?.AI_parsed_data?.parsed_data);
      setDocument_id(response.data.data?._id)
      setAssetLink(response.data?.data?.asset_link)
      setRowData(response.data?.data?.two_b_matches);
      setTotalCount(response?.data?.totalCount)
      setCurrentDoc(response.data?.seenCount)
      setClientGSTIN(response.data?.data?.guest_gstin || ""); // Map GSTIN to first input box
      setClientEnteredGSTIN(""); // Clear second input box
      setWorkspaceStatusTag("Validation Required");
      setHotelStatusTag("Validation Required");
      setParsedStatusTag("Validation Required");
      setDynamicFieldValues({}); // Reset dynamic field values when fetching new document
      setDynamicFieldInputValues({}); // Reset first input box values
      
      // Auto-populate Show More fields (second input boxes) with original values
      const parsedData = response?.data?.data?.AI_parsed_data?.parsed_data;
      const initialOutputValues = {};
      if (parsedData) {
        const excludedFields = [
          'total_tax_amount',
          'invoice_number',
          'invoice_amount',
          'invoice_date',
          'guest_gstin',
          'hotel_gstin',
          'hotel_name'
        ];
        
        Object.entries(parsedData).forEach(([key, originalValue]) => {
          // Only auto-populate Show More fields that exist (not null/undefined) and are not excluded
          const fieldExists = originalValue !== null && originalValue !== undefined;
          if (!excludedFields.includes(key) && fieldExists) {
            // Auto-populate with original value (including "", 0, [])
            initialOutputValues[key] = originalValue;
          }
        });
      }
      setDynamicFieldOutputValues(initialOutputValues);
      
      // Reset validation errors
      setValidationErrors({
        clientGSTIN: false,
        hotelName: false,
        hotelGSTIN: false,
        gstAmount: false,
        invoiceNumber: false,
        invoiceAmount: false,
        invoiceDate: false,
        showMoreFields: {}
      });
      setIsSaveDisabled(true); // Disable save button for new document
    }
    setLoading(false);
  };

  const fetchClientInfoByPan = async (retryCount = 0) => {
    setClientListLoading(true);
    try {
      const response = await axios.get(
        "https://stage-apiplatform.finkraftai.com/api/fuzzy/clientInfo/pan"
      );
      console.log(response, "response in fetchClientInfoByPan");
      if (response.status && response.data?.status && response.data?.data) {
        setClientList(response.data.data);
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching client info by PAN:", error);
      
      // Retry logic: retry up to 3 times with exponential backoff
      if (retryCount < 3) {
        const delay = Math.pow(2, retryCount) * 1000; // 1s, 2s, 4s
        console.log(`Retrying fetchClientInfoByPan in ${delay}ms... (attempt ${retryCount + 1})`);
        setTimeout(() => {
          fetchClientInfoByPan(retryCount + 1);
        }, delay);
        return null;
      }
      
      // Only show error message after all retries failed
      if (retryCount >= 3) {
        messageApi.open({
          type: "error",
          content: "Failed to fetch client info. Please try again later.",
          duration: 3,
        });
      }
      return null;
    } finally {
      // Only set loading to false if not retrying
      if (retryCount >= 3 || retryCount === 0) {
        setClientListLoading(false);
      }
    }
  };

  const handleClientSelect = async (clientId) => {
    const selectedClientData = clientList.find(client => client._id === clientId);
    if (selectedClientData) {
      setSelectedClient(selectedClientData);
      // Set first PAN as default if available
      const panNumber = selectedClientData.pan_numbers?.[0] || "";
      setSelectedClientPan(panNumber);
      
      // Call fetchDocument with client_name filter using the client name
      if (selectedClientData.client_name) {
        await fetchDocument({ type: "client_name", value: selectedClientData.client_name });
      }
    }
  };

  const handlePanSelect = (panNumber) => {
    setSelectedClientPan(panNumber);
  };

  // Fetch client list initially on component mount
  useEffect(() => {
    // Add a small delay to ensure API is ready after page refresh
    const timer = setTimeout(() => {
      fetchClientInfoByPan();
    }, 500); // 500ms delay
    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (matchDocument) {
      // Call the function only when matchDocument is present
      fetch2bmatchsElastic();// Uncomment if needed
      fetchBookingElasticMatches();
    }
  }, [matchDocument]);



  const fetch2bmatchsElastic = async (input = "") => {
    const scroll_time = "2m"
    const batch_size = 50
    const esUrl =
      "https://dev-elastic.finkraftai.com";

    let queryParts = [];
    const headers = {
      'Content-Type': 'application/json',
    };
    // Include GSTINs only if skipGSTIN is false
    if (!skipGSTIN) {
      if (hotelGSTIN) {
        queryParts.push(`${hotelGSTIN}`);
      } else if (matchDocument?.hotel_gstin) {
        queryParts.push(`${matchDocument?.hotel_gstin}`);
      }

      if (clientGSTIN) {
        queryParts.push(`${clientGSTIN}`);
      } else if (matchDocument?.guest_gstin) {
        queryParts.push(`${matchDocument?.guest_gstin}`);
      }
    }
    // Process user input from search bar
    const userQueries = input
      .split(",")
      .map((term) => term.trim())
      .filter((term) => term);

    if (userQueries.length > 0) {
      queryParts = queryParts.concat(userQueries.map((term) => `${term}`));
    }
    // Construct the final query string
    const queryStr = queryParts.length ? queryParts.join(" AND ") : "";

    const searchQuery = {
      size: batch_size,
      query: {
        query_string: {
          query: queryStr,
          fields: ["*"],
          default_operator: "AND",
          fuzziness: "AUTO",
          lenient: true
        }
      },
      sort: [{ _score: { order: "desc" } }]
    };


    try {

      const response = await axios.post(
        `${esUrl}/hotel_2b_data_clear_trip/_search?scroll=${scroll_time}`,
        searchQuery, // ✅ This goes into the body
        { headers }
      );
      const hits = response.data?.hits.hits || [];
      if (hits.length > 0) {
        setRowData(hits.map((hit) => hit._source));
      } else {
        // If input (search term) was used and no results were found, update state to skip GSTIN for the next search
        if (input) {
          setSkipGSTIN(true);
        }
        setRowData([]);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  const fetchBookingElasticMatches = async (input = "") => {
    const scroll_time = "2m"
    const batch_size = 50
    const esUrl =
      "https://dev-elastic.finkraftai.com";

    let queryParts = [];
    const headers = {
      'Content-Type': 'application/json',
    };
    // Include GSTINs only if skipGSTIN is false
    if (!skipGSTIN) {
      if (hotelGSTIN) {
        queryParts.push(`${hotelGSTIN}`);
      } else if (matchDocument?.hotel_gstin) {
        queryParts.push(`${matchDocument?.hotel_gstin}`);
      }

      if (clientGSTIN) {
        queryParts.push(`${clientGSTIN}`);
      } else if (matchDocument?.guest_gstin) {
        queryParts.push(`${matchDocument?.guest_gstin}`);
      }
    }
    // Process user input from search bar
    const userQueries = input
      .split(",")
      .map((term) => term.trim())
      .filter((term) => term);

    if (userQueries.length > 0) {
      queryParts = queryParts.concat(userQueries.map((term) => `${term}`));
    }
    // Construct the final query string
    const queryStr = queryParts.length ? queryParts.join(" AND ") : "";

    const searchQuery = {
      size: batch_size,
      query: {
        query_string: {
          query: queryStr,
          fields: ["*"],
          default_operator: "AND",
          fuzziness: "AUTO",
          lenient: true
        }
      },
      sort: [{ _score: { order: "desc" } }]
    };


    try {

      const response = await axios.post(
        `${esUrl}/hotel_booking_data/_search?scroll=${scroll_time}`,
        searchQuery, // ✅ This goes into the body
        { headers }
      );
      const hits = response.data?.hits.hits || [];
      if (hits.length > 0) {
        setRowData(hits.map((hit) => hit._source));
      } else {
        // If input (search term) was used and no results were found, update state to skip GSTIN for the next search
        if (input) {
          setSkipGSTIN(true);
        }
        setRowData([]);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };




  const handlePopulateClientDetails = async (gstinNumber) => {
    console.log(gstinNumber, "inside handlePopulateClientDetails")
    setClientLoading(true);
    if (validateGSTIN(gstinNumber)) {
      setClientEnteredGSTIN(gstinNumber);
      const response = await axios.post(
        "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/clientgstin/info",
        {
          gstin: gstinNumber,
        }
      );
      console.log("response in  client gstin", response)
      if (response.status && (response.data.data !== null && response.data.data.length > 0)) {
        setEnableClientGSTIN(false)
        setClientGSTIN(gstinNumber);
        setClientWorkspace(response.data.data?.[0]?.name);
        setWorkspaceStatusTag("Validate");
      } else {
        setWorkspaceStatusTag("GSTIN not found in DB");
        setEnableClientGSTIN(true)
        messageApi.open({
          type: "error",
          content: "No GSTIN found",
        });
      }
    } else {
      messageApi.open({
        type: "error",
        content: "Enter valid GSTIN"
      })
    }
    setClientLoading(false);
  };

  const handlePopulateHotelDetails = async (gstinNumber) => {
    setHotelLoading(true);
    if (validateGSTIN(gstinNumber)) {
      setHotelEnteredGSTIN(gstinNumber);
      const response = await axios.post(
        "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/hotelgstin/info",
        {
          gstin: gstinNumber,
        }
      );
      if (response.status && response.data.data !== null) {
        setHotelGSTIN(gstinNumber);
        setEnableHotelCreate(false);
        console.log("response:", response.data);
        setHotelName(response.data.data["Hotel Name"]);
        setHotelStatusTag("Validated")
      } else {
        setHotelStatusTag("GSTIN not found in db")
        setEnableHotelCreate(true)
        messageApi.open({
          type: "error",
          content: "Hotel details could not found",
        });
      }
    }
    else {
      messageApi.open({
        type: "error",
        content: "Enter valid GSTIN"
      })
    }
    setHotelLoading(false);
  };


  const handleCreateHotelWithGstin = async () => {
    const response = await axios.post(
      "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/hotel/create",
      {
        gstin: hotelEnteredGSTIN,
        hotel_name: matchDocument?.mapped_invoice_data?.hotel_name,
        tobescraped: true,
      }
    );
    if (response.status && response.data.data !== null) {
      messageApi.open({
        type: "success",
        content: "Hotel Created Successfully",
      });
      setEnableHotelCreate(false);
      setHotelGSTIN(hotelEnteredGSTIN);
      setHotelName(matchDocument?.hotel_name);
    } else {
      messageApi.open({
        type: "error",
        content: "Workspace details could not found",
      });
    }
  };

  // Debounced version of fetchUsers
  // const debouncedFetchUsers = useCallback(
  //   debounce(fetch2bmatchsElastic, 300),
  //   []
  // );

  // const handleInputChange = (event) => {
  //   const inputValue = event.target.value;
  //   debouncedFetchUsers(inputValue);
  // };

  const handleSaveCollection = async () => {
    // Validate all fields before saving
    const isValid = validateAllFields();
    if (!isValid) {
      messageApi.open({
        type: "error",
        content: "Please fill all required fields before saving",
        duration: 3,
      });
      return;
    }

    const payload = {
      documentId: document_id || documentId,
      two_b_data: selected2BMatch?._source
        ? { ...selected2BMatch?._source }
        : selected2BMatch,
      booking_match: selectedBookingMatch?._source,
      // Food_996332_amount: parseInt(validatedHSN332Amount),
      total_tax_amount: validatedGSTAmount,
      invoice_amount: validatedInvoiceAmount,
      // workspace: clientWorkspace || matchDocument?.validated_data?.workspace,
      guest_gstin:
        clientGSTIN || matchDocument?.guest_gstin,
      hotel_name: hotelName || matchDocument?.hotel_name,
      hotel_gstin:
        hotelGSTIN || matchDocument?.hotel_gstin,
      // Amount996331: amount996331,
      // Amount996332: amount996332,
      // Amount996334: amount996334,
      // Amount996339: amount99639,
      // Amount996311: amount996311,
      invoice_number: invoiceNumber || matchDocument?.invoice_number,
      selected_issue: selectedIssue,
      invoice_date: validatedInvoiceDate || matchDocument?.invoice_date,
      remarks: remarks,
      // Include all dynamic field values from "Show More" (mandatory second input box)
      ...dynamicFieldOutputValues,
    };
    console.log(payload, "payload")
    const response = await axios.post(
      "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/update",
      // "http://localhost:7002/api/fuzzy/match_document/update",
      payload
    );
    if (response.status) {
      setEnableHotelCreate("")
      setEnableClientGSTIN("")
      setHotelEnteredGSTIN("");
      setHotelGSTIN("");
      setHotelName("");
      setClientEnteredGSTIN("");
      setClientWorkspace("");
      setClientWorkspace("");
      setValidatedGSTAmount("");
      setValidatedHSN332Amount("");
      setValidatedInvoiceAmount("");
      setRemarks("");
      setSelectedIssue("");
      setSelected2BMatch(null);
      setSelectedBookingMatch(null);
      setInvoiceNumber("")
      setValidatedInvoiceDate("")
      setDynamicFieldValues({}); // Reset dynamic field values
      setDynamicFieldInputValues({}); // Reset first input box values
      setDynamicFieldOutputValues({}); // Reset second input box values
      fetchDocument();
    }
    console.log("payload", payload);
  };

  const handleSkipDocument = async () => {
    console.log("Inside skip function")
    console.log(document_id, "document_id")
    const response = await axios.post(
      // "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/skip/" +
      "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/skip/" +
      document_id
    );
    if (response.status) {
      setEnableHotelCreate("")
      setEnableClientGSTIN("")
      setWorkspaceStatusTag("");
      setHotelStatusTag("");
      setParsedStatusTag("");
      setHotelEnteredGSTIN("");
      setHotelGSTIN("");
      setHotelName("");
      setClientGSTIN(""); // Clear first input box
      setClientEnteredGSTIN(""); // Clear second input box
      setClientWorkspace("");
      setClientWorkspace("");
      setValidatedGSTAmount("");
      setValidatedHSN332Amount("");
      setValidatedInvoiceAmount("");
      setInvoiceNumber("")
      setRemarks("");
      setSelectedIssue("");
      setSelected2BMatch(null);
      setSelectedBookingMatch(null);
      setAmount996331("")
      setAmount996334("")
      setAmount996339("")
      setAmount996311("")
      setInvoiceNumber("")
      
      // Preserve filter when skipping - apply same filter to next document
      if (filterType !== "All" && filterValue) {
        const filterParams = {
          type: filterType,
          value: filterValue,
        };
        // Add PAN numbers if client_name filter is active
        if (filterType === "client_name" && currentFilterPanNumbers.length > 0) {
          filterParams.pan_numbers = currentFilterPanNumbers;
        }
        // Add GSTIN numbers if client_gstin or hotel_gstin filter is active
        if ((filterType === "client_gstin" || filterType === "hotel_gstin") && currentFilterGstinNumbers.length > 0) {
          filterParams.gstin_numbers = currentFilterGstinNumbers;
        }
        fetchDocument(filterParams);
      } else {
        fetchDocument();
      }
    }
  };

  const handleRedirectToCRM = async (gstinNumber) => {
    const response = await axios.get(
      "https://stage-apiplatform.finkraftai.com/api/fuzzy/hotelInfo/" + gstinNumber
    );
    if (response.status) {
      console.log("response:", response);
      window.open(
        "https://crm.zoho.in/crm/org60016690758/tab/Accounts/" +
        response.data.data.zoho_crm_id
      );
    }
  };


  const handleCopyData = (copyText, isDate = false) => {
    let textToCopy = copyText;
    if (isDate) {
      textToCopy = moment(copyText).format("DD-MM-YYYY");
      console.log(textToCopy, "Text to copy")
    }
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          console.log("Text copied to clipboard");
          messageApi.success({
            type: "success",
            content: "Copied",
          });
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      // Clipboard API not supported, fallback to older method
      fallbackCopyTextToClipboard(textToCopy);
    }
  };

  function fallbackCopyTextToClipboard(text) {
    // Create a temporary textarea element
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      // Execute the copy command
      document.execCommand("copy");
      console.log("Text copied to clipboard");
      messageApi.success({
        type: "success",
        content: "Copied",
      });
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }

    // Remove the temporary textarea element
    document.body.removeChild(textArea);
  }


  const handleWorkspaceChange = (newData, type) => {
    if (type === "workspace") {
      setWorkspaceStatusTag("Validated");
    } else if (type === "hotel") {
      setHotelStatusTag("Validated");
    }
    else if (type === "parsed") {
      setParsedStatusTag("Validated")
    }
  };


  // Initialize refs for the inputs of each section
  // const sectionRefs = {
  //   "1": useRef(),
  //   "2": useRef(),
  //   "3":useRef(),
  //   "4":useRef(),
  //   "5":useRef()
  // };

  const handleKeyDown = (e, sectionKey) => {
    if (e.key === "ArrowDown") {
      const nextKey = getNextSectionKey(sectionKey);
      sectionRefs[nextKey]?.current?.focus();  // Focus on the next section
    } else if (e.key === "ArrowUp") {
      const prevKey = getPrevSectionKey(sectionKey);
      sectionRefs[prevKey]?.current?.focus();  // Focus on the previous section
    }
  };

  const getNextSectionKey = (currentKey) => {
    const sectionKeys = ["1", "2", "3", "4", "5"];
    const currentIndex = sectionKeys.indexOf(currentKey);
    return sectionKeys[(currentIndex + 1) % sectionKeys.length];  // Wrap around if necessary
  };

  const getPrevSectionKey = (currentKey) => {
    const sectionKeys = ["1", "2", "3", "4", "5"];
    const currentIndex = sectionKeys.indexOf(currentKey);
    return sectionKeys[(currentIndex - 1 + sectionKeys.length) % sectionKeys.length];  // Wrap around if necessary
  };




  const handleCollapseChange = (key) => {
    // Retain the original functionality to focus on the section container
    if (key === "1") {
      sectionRefs["1"]?.current?.focus();
      // Fetch client list when client section is opened
      if (clientList.length === 0) {
        fetchClientInfoByPan();
      }
    } else if (key === "2") {
      sectionRefs["2"]?.current?.focus();
    } else if (key === "3") {
      sectionRefs["3"]?.current?.focus();
    } else if (key === "4") {
      sectionRefs["4"]?.current?.focus();
    } else if (key === "5") {
      sectionRefs["5"]?.current?.focus();
    }
  };

  const handleFieldKeyDown = (e, sectionKey) => {
    // Hardcoded refs for each section using numeric keys like "11", "12", etc.
    const sectionInputs = {
      "1": [
        sectionRefs["11"],
        sectionRefs["12"],
        sectionRefs["13"],
        sectionRefs["14"],
        sectionRefs["15"],
        sectionRefs["16"],
        sectionRefs["17"],
        sectionRefs["18"],
        sectionRefs["19"]
      ],  // Inputs and div for section 1

      "2": [

        sectionRefs["21"],
        sectionRefs["22"],
        sectionRefs["23"],
        sectionRefs["24"],
        sectionRefs["25"],
        sectionRefs["26"],
        sectionRefs["27"],
        sectionRefs["28"],
        sectionRefs["29"],
        sectionRefs["30"]
      ],

      "3": [
        sectionRefs["31"],
        sectionRefs["32"],
        sectionRefs["33"],
        sectionRefs["34"],
        sectionRefs["35"],
        sectionRefs["36"],
        sectionRefs["37"],
        sectionRefs["38"],
        sectionRefs["39"],
        sectionRefs["311"],
        sectionRefs["312"],
        sectionRefs["313"],
        sectionRefs["314"],
        sectionRefs["315"],
        sectionRefs["316"],
        sectionRefs["317"],
        sectionRefs["318"],
        sectionRefs["319"],
        sectionRefs["320"],
        sectionRefs["321"],
        sectionRefs["322"],
        sectionRefs["323"],
        sectionRefs["324"],
        sectionRefs["325"],
        sectionRefs["326"],
        sectionRefs["327"],
        sectionRefs["328"],
        sectionRefs["329"],
        sectionRefs["330"],
        sectionRefs["331"],
        sectionRefs["332"],
        sectionRefs["333"],
        sectionRefs["334"],
        sectionRefs["335"],
        sectionRefs["336"],
        sectionRefs["337"],
        sectionRefs["338"],


      ],

      // Add other sections with their inputRefs and divRefs here as needed
      "4": [

        sectionRefs["41"],
        sectionRefs["42"]
      ],
      "5": [

        sectionRefs["51"],

      ],
    };

    // Get the currently focused element in the section
    const sectionInputArray = sectionInputs[sectionKey];
    console.log("Section Key:", sectionKey);
    console.log("Section input", sectionInputs)
    console.log(sectionInputArray, "sectionInputArray")
    const currentIndex = sectionInputArray.findIndex(
      (ref) => ref?.current === document.activeElement
    );
    console.log("currentIndex", currentIndex)

    console.log('Pressed key', e.key);

    if (e.key === "Enter") {
      const focusedElement = document.activeElement;

      if (focusedElement) {
        // ✅ Trigger the onClick event of the focused element
        focusedElement.click();
      }
      if (e.key === "Tab" && e.shiftKey) {
        if (currentIndex > 0) {
          // Focus on the previous field
          const previousField = sectionInputArray[currentIndex - 1];
          previousField?.current?.focus();
        } else {
          // Optionally, handle the case where you are at the first input
          // (for example, focus on the last field of the section or move to the previous section)
          // Uncomment and adjust as needed.
          // sectionInputArray[sectionInputArray.length - 1]?.current?.focus();
        }
      }


    }


  };

  const sectionRefs = {
    "1": useRef(),
    "2": useRef(),
    "3": useRef(),
    "4": useRef(),
    "5": useRef(),
    "11": useRef(),
    "12": useRef(),
    "13": useRef(),
    "14": useRef(),
    "15": useRef(),
    "16": useRef(),
    "17": useRef(),
    "18": useRef(),
    "19": useRef(),



  };
  // const sectionInputs = {
  //   "1": [sectionRefs["11"], sectionRefs["12"], sectionRefs["13"], sectionRefs["14"],sectionRefs["15"], sectionRefs["16"], sectionRefs["17"], sectionRefs["18"], sectionRefs["19"], sectionRefs["20"]], // Add the relevant refs for section 1
  //   "2": [sectionRefs["21"], sectionRefs["22"], sectionRefs["23"], sectionRefs["24"], sectionRefs["25"],sectionRefs["26"], sectionRefs["27"], sectionRefs["28"],sectionRefs["29"], sectionRefs["30"]],
  //   "3": [sectionRefs["31"], sectionRefs["32"]],
  //   // Add other sections as necessary
  // };
  // const handleFieldKeyDown = (e, sectionKey) => {
  //   // Get section refs for this section
  //   const sectionInputArray = sectionInputs[sectionKey];

  //   // Log to ensure `sectionInputArray` is correct
  //   console.log("Section input array:", sectionInputArray);

  //   // Find the element currently in focus
  //   console.log("Document active element:", document.activeElement);

  //   // Find the index of the element that matches the activeElement
  //   const currentIndex = sectionInputArray.findIndex((ref) => {
  //     console.log("Comparing:", ref.current, document.activeElement);
  //     return ref.current === document.activeElement;
  //   });

  //   console.log("Current index:", currentIndex);

  //   // Handle key events based on current index
  //   switch (e.key) {
  //     case "ArrowDown":
  //       if (currentIndex < sectionInputArray.length - 1) {
  //         sectionInputArray[currentIndex + 1].current?.focus();
  //       }
  //       break;
  //     case "ArrowUp":
  //       if (currentIndex > 0) {
  //         sectionInputArray[currentIndex - 1].current?.focus();
  //       }
  //       break;
  //     case "ArrowLeft":
  //       if (currentIndex > 0) {
  //         // Logic for handling left arrow: You could move left within the same row/section.
  //         sectionInputArray[currentIndex - 1].current?.focus();
  //       }
  //       break;
  //     case "ArrowRight":
  //       if (currentIndex < sectionInputArray.length - 1) {
  //         // Logic for handling right arrow: You could move right within the same row/section.
  //         sectionInputArray[currentIndex + 1].current?.focus();
  //       }
  //       break;
  //     case "Enter":
  //       console.log("Enter key pressed");
  //       // You can add your own logic here for the Enter key, such as:
  //       // - Triggering a form submission
  //       // - Selecting the current element
  //       // - Navigating to another section
  //       // Example: If it's a button, you could trigger its action
  //       // sectionInputArray[currentIndex].current?.click(); // If it's clickable
  //       break;
  //     default:
  //       break;
  //   }
  // };


console.log(matchDocument?.vali)


  const items = [
    {
      key: "1",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }}
          ref={sectionRefs["1"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "1")}>
          <div style={{ width: "50%" }}>Client Detail</div>
          <div style={{ width: "30%" }}>
            {/* <Tag color="green" icon={<CheckOutlined />}>
              Status
            </Tag> */}
            <Tag color={workspaceStatusTag === "Validated" ? "green" : "red"} >
              {workspaceStatusTag}
            </Tag>
          </div>
        </div>
      ),
      children: (
        <div style={{ width: "100%" }} >

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["16"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "1")}>Client GSTIN</div>
            <div
              style={{ width: "33%", display: "flex", alignItems: "center" }}
            >
              <Input
                ref={sectionRefs["17"]} 
                tabIndex={0} 
                onKeyDown={(e) => handleFieldKeyDown(e, "1")}
                size="small"
                placeholder="Client GSTIN"
                style={{ width: 200 }}
                suffix={clientLoading ? <LoadingOutlined /> : null}
                value={clientGSTIN || matchDocument?.guest_gstin || ""}
                onChange={(e) => {
                  setClientGSTIN(e.target.value);
                }}
              />
        
              <CopyOutlined 
                style={{ marginLeft: 24, cursor: "pointer" }}
                ref={sectionRefs["18"]} 
                tabIndex={0} 
                onKeyDown={(e) => handleFieldKeyDown(e, "1")}
                onClick={() => handleCopyData(matchDocument?.guest_gstin)}
              />
              <ArrowRightOutlined
                ref={sectionRefs["19"]} 
                tabIndex={0} 
                onKeyDown={(e) => handleFieldKeyDown(e, "1")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const gstinValue = clientGSTIN || matchDocument?.guest_gstin || "";
                  if (gstinValue && gstinValue.trim()) {
                    setClientEnteredGSTIN(gstinValue.trim());
                    fetch2bmatchsElastic(gstinValue.trim());
                  }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
                <Input
                ref={sectionRefs["20"]} 
                tabIndex={0} 
                onKeyDown={(e) => handleFieldKeyDown(e, "1")}
                  size="small"
                placeholder="Client GSTIN"
                style={{ 
                  width: 200,
                  borderColor: validationErrors.clientGSTIN ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.clientGSTIN ? "2px" : undefined
                }}
                value={clientEnteredGSTIN}
                  onChange={(e) => {
                  setClientEnteredGSTIN(e.target.value);
                }}
                onPressEnter={(e) => {
                  const value = e.target.value.trim();
                  if (value) {
                    setClientEnteredGSTIN(value);
                    fetch2bmatchsElastic(value);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value.trim();
                  if (value) {
                    setClientEnteredGSTIN(value);
                    fetch2bmatchsElastic(value);
                  }
                  validateAllFields();
                }}
                required
              />
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }}
          ref={sectionRefs["2"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "2")}>
          <div style={{ width: "50%" }}  >Hotel Detail</div>
          <div style={{ width: "30%" }}>
            {/* <Tag color="green" icon={<CheckOutlined />}>
              Status
            </Tag> */}
            <Tag color={hotelStatusTag === "Validated" ? "green" : "red"} >
              {hotelStatusTag}
            </Tag>
          </div>
          <div
            style={{
              width: "10%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {/* <Tag
              color="blue"
              icon={<ExportOutlined />}
              onClick={() =>
                handleRedirectToCRM(
                  matchDocument?.hotel_gstin || hotelGSTIN
                )
              }
            >
              CRM
            </Tag> */}
          </div>
        </div>
      ),
      children: (
        <div style={{ width: "100%" }}>
          <div style={{ widht: "100%", display: "flex", alignItems: "center" }}>
            <div style={{ width: "33%" }} ref={sectionRefs["21"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}>Hotel Name</div>
            <div style={{ width: "33%" }} >
              <span ref={sectionRefs["22"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}> {matchDocument?.hotel_name}</span>

              <CopyOutlined style={{ marginLeft: 24 }} ref={sectionRefs["23"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                onClick={() =>
                  handleCopyData(matchDocument?.hotel_name)
                } />
              <ArrowRightOutlined
                ref={sectionRefs["24"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                style={{ marginLeft: 24, color: "#0A8394" }}
                onClick={() => {
                  setHotelName(matchDocument?.hotel_name);
                  handleWorkspaceChange(matchDocument?.hotel_name, "hotel")
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["25"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                size="small"
                placeholder="HotelName"
                value={hotelName}
                onChange={(e) => setHotelName(e.target.value)}
                onBlur={() => validateAllFields()}
                style={{
                  borderColor: validationErrors.hotelName ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.hotelName ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>

          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["26"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}>Hotel GSTIN</div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["27"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                size="small"
                placeholder="Hotel GSTIN"
                style={{ width: 200 }}
                value={hotelGSTIN || matchDocument?.hotel_gstin || ""}
                onChange={(event) => {
                  handlePopulateHotelDetails(event.target.value);
                  setHotelGSTIN(event.target.value);
                }}
                suffix={hotelLoading ? <LoadingOutlined /> : null}
              />
              <CopyOutlined style={{ marginLeft: 24 }} ref={sectionRefs["28"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")} 
                 onClick={() =>
                  handleCopyData(matchDocument?.hotel_gstin)
                } />
              <ArrowRightOutlined
                ref={sectionRefs["29"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const gstinValue = hotelGSTIN || matchDocument?.hotel_gstin || "";
                  if (gstinValue && gstinValue.trim()) {
                    setHotelGSTIN(gstinValue.trim());
                  fetch2bmatchsElastic();
                }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
          
                <Input
                  ref={sectionRefs["30"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                  size="small"
                  placeholder="Hotel GSTIN"
                  value={hotelGSTIN}
                  onChange={(e) => setHotelGSTIN(e.target.value)}
                  onBlur={() => validateAllFields()}
                  style={{
                    borderColor: validationErrors.hotelGSTIN ? "rgb(236 158 159)" : undefined,
                    borderWidth: validationErrors.hotelGSTIN ? "2px" : undefined
                  }}
                  required
                />
              
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }} ref={sectionRefs["3"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "3")}>
          <div style={{ width: "50%" }}>Parsed data from Invoice</div>
          <div style={{ width: "30%" }}>
            <Tag color={parsedStatusTag === "Validated" ? "green" : "red"} >
              {parsedStatusTag}
            </Tag>
          </div>
        </div>
      ),
      children: (
        <div style={{ width: "100%" }}>
          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["325"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>GST Amount</div>
            <div style={{ width: "33%" }} >
              <span ref={sectionRefs["326"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>{matchDocument?.total_tax_amount}</span>

              <CopyOutlined
                ref={sectionRefs["327"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24 }} onClick={() =>
                  handleCopyData(matchDocument?.total_tax_amount)
                } />
              <ArrowRightOutlined
                ref={sectionRefs["328"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  setValidatedGSTAmount(
                    matchDocument?.total_tax_amount
                  )
                  handleWorkspaceChange(matchDocument?.total_tax_amount, "parsed")
                }
                }
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["329"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="GST Amount"
                value={validatedGSTAmount}
                onChange={(event) => setValidatedGSTAmount(event.target.value)}
                onBlur={() => validateAllFields()}
                style={{
                  borderColor: validationErrors.gstAmount ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.gstAmount ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>
          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["330"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>Invoice Number</div>
            <div style={{ width: "33%" }}>
              <span ref={sectionRefs["330"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}> {matchDocument?.invoice_number}</span>

              <CopyOutlined style={{ marginLeft: 24 }}
                ref={sectionRefs["331"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                onClick={() =>
                  handleCopyData(matchDocument?.invoice_number)
                } />
              <ArrowRightOutlined
                ref={sectionRefs["332"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  setInvoiceNumber(
                    matchDocument?.invoice_number
                  )
                  handleWorkspaceChange(matchDocument?.invoice_number, "parsed")
                }
                }

              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["333"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Number"
                value={invoiceNumber}
                onChange={(event) => setInvoiceNumber(event.target.value)}
                onBlur={() => validateAllFields()}
                style={{
                  borderColor: validationErrors.invoiceNumber ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.invoiceNumber ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>
          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["334"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>Invoice Amount</div>
            <div style={{ width: "33%" }}>
              <span ref={sectionRefs["335"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>{matchDocument?.invoice_amount}</span>
              <CopyOutlined style={{ marginLeft: 24 }} data-row="11"
                ref={sectionRefs["336"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                onClick={() =>
                  handleCopyData(matchDocument?.invoice_amount)
                } />
              <ArrowRightOutlined
                ref={sectionRefs["337"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() =>
                  setValidatedInvoiceAmount(
                    matchDocument?.invoice_amount
                  )
                }
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["338"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Amount"
                value={validatedInvoiceAmount}
                onChange={(event) =>
                  setValidatedInvoiceAmount(event.target.value)
                }
                onBlur={() => validateAllFields()}
                style={{
                  borderColor: validationErrors.invoiceAmount ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.invoiceAmount ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>
          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["334"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>Invoice Date</div>
            <div style={{ width: "33%" }}>
              <span ref={sectionRefs["335"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>{matchDocument?.invoice_date}</span>
              <CopyOutlined style={{ marginLeft: 24 }} data-row="11"
                ref={sectionRefs["336"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                onClick={() =>
                  handleCopyData(matchDocument?.invoice_date)
                } />
              <ArrowRightOutlined
                ref={sectionRefs["337"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() =>
                  setValidatedInvoiceDate(
                    matchDocument?.invoice_date
                  )
                }
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["338"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Date"
                value={validatedInvoiceDate}
                onChange={(event) =>
                  setValidatedInvoiceDate(event.target.value)
                }
                onBlur={() => validateAllFields()}
                style={{
                  borderColor: validationErrors.invoiceDate ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.invoiceDate ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>
          
          {/* Show More Button */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: 12,
            }}
          >
            <Button
              type="link"
              onClick={() => setShowMoreParsedData(!showMoreParsedData)}
            >
              {showMoreParsedData ? "Show Less" : "Show More"}
            </Button>
          </div>

          {/* Dynamically rendered additional fields */}
          {showMoreParsedData && matchDocument && (
            <>
              {Object.entries(matchDocument).map(([key, value]) => {
                // Skip already displayed fields
                const excludedFields = [
                  'total_tax_amount',
                  'invoice_number',
                  'invoice_amount',
                  'invoice_date',
                  'guest_gstin',
                  'hotel_gstin',
                  'hotel_name'
                ];
                
                if (excludedFields.includes(key)) {
                  return null;
                }

                // Format field name (convert snake_case to Title Case)
                const formatFieldName = (str) => {
                  return str
                    .split('_')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
                };

                // Check if value is an object or array
                const isObjectOrArray = value !== null && typeof value === 'object';
                
                // Convert value to display string
                const getDisplayValue = (val) => {
                  if (val === null || val === undefined) return "-";
                  if (isObjectOrArray) {
                    return JSON.stringify(val, null, 2);
                  }
                  return String(val);
                };

                // Check if field exists in original document
                const fieldExists = value !== null && value !== undefined;
                
                // Get the first input value (from state or original document value)
                // Handle 0, [], and "" as valid values (don't convert them)
                const getFirstInputDefault = () => {
                  if (!fieldExists) return "";
                  if (isObjectOrArray) {
                    // Handle empty arrays as valid - show as "[]"
                    if (Array.isArray(value) && value.length === 0) return "[]";
                    return JSON.stringify(value, null, 2);
                  }
                  // For numbers, preserve 0 as valid value
                  if (typeof value === 'number') return String(value);
                  // For strings, preserve empty string "" as valid value
                  if (typeof value === 'string') return value; // This includes "" as valid
                  // For other types, convert to string or empty string
                  return value !== null && value !== undefined ? String(value) : "";
                };
                const firstInputValue = dynamicFieldInputValues[key] !== undefined
                  ? dynamicFieldInputValues[key]
                  : getFirstInputDefault();

                // Get the second input value (auto-populated for Show More fields)
                const secondInputValue = dynamicFieldOutputValues[key] !== undefined
                  ? dynamicFieldOutputValues[key]
                  : "";

                // Handle first input value change
                const handleFirstInputChange = (newValue) => {
                  setDynamicFieldInputValues(prev => ({
                    ...prev,
                    [key]: newValue
                  }));
                };

                // Handle second input value change
                const handleSecondInputChange = (newValue) => {
                  if (isObjectOrArray) {
                    // Try to parse JSON, if fails keep as string
                    try {
                      const parsed = JSON.parse(newValue);
                      // Handle empty array [] - it's a valid value
                      setDynamicFieldOutputValues(prev => ({
                        ...prev,
                        [key]: parsed
                      }));
                      setDynamicFieldValues(prev => ({
                        ...prev,
                        [key]: parsed
                      }));
                    } catch (e) {
                      // Invalid JSON or empty array string "[]"
                      if (newValue.trim() === "[]") {
                        // Explicitly handle empty array
                        setDynamicFieldOutputValues(prev => ({
                          ...prev,
                          [key]: []
                        }));
                        setDynamicFieldValues(prev => ({
                          ...prev,
                          [key]: []
                        }));
                      } else {
                        // Invalid JSON, store as string temporarily
                        setDynamicFieldOutputValues(prev => ({
                          ...prev,
                          [key]: newValue
                        }));
                        setDynamicFieldValues(prev => ({
                          ...prev,
                          [key]: newValue
                        }));
                      }
                    }
                  } else {
                    // For non-object/array values, preserve type
                    let processedValue = newValue;
                    if (typeof value === 'number') {
                      // Try to parse as number, preserve 0
                      const numValue = newValue === "" ? null : (isNaN(Number(newValue)) ? newValue : Number(newValue));
                      processedValue = numValue;
                    } else if (typeof value === 'string') {
                      // Preserve empty string "" as valid value
                      processedValue = newValue; // Keep as string, including ""
                    }
                    setDynamicFieldOutputValues(prev => ({
                      ...prev,
                      [key]: processedValue
                    }));
                    setDynamicFieldValues(prev => ({
                      ...prev,
                      [key]: processedValue
                    }));
                  }
                };

                return (
                  <div
                    key={key}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: isObjectOrArray ? "flex-start" : "center",
                      marginTop: 12,
                    }}
                  >
                    <div style={{ width: "33%", paddingTop: isObjectOrArray ? 8 : 0 }}>{formatFieldName(key)}</div>
                    <div style={{ width: "33%", display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                      {isObjectOrArray ? (
                        <TextArea
                          size="small"
                          placeholder={formatFieldName(key)}
                          style={{ width: 200, fontFamily: "monospace", fontSize: 12 }}
                          value={typeof firstInputValue === 'string' ? firstInputValue : JSON.stringify(firstInputValue, null, 2)}
                          onChange={(e) => handleFirstInputChange(e.target.value)}
                          rows={4}
                        />
                      ) : (
                        <Input
                          size="small"
                          placeholder={formatFieldName(key)}
                          style={{ width: 200 }}
                          value={firstInputValue}
                          onChange={(e) => handleFirstInputChange(e.target.value)}
                        />
                      )}
                      <CopyOutlined
                        style={{ 
                          marginLeft: 24, 
                          cursor: fieldExists ? "pointer" : "not-allowed",
                          opacity: fieldExists ? 1 : 0.5
                        }}
                        onClick={() => {
                          if (fieldExists) {
                            handleCopyData(isObjectOrArray ? JSON.stringify(value, null, 2) : value);
                          }
                        }}
                      />
                      <ArrowRightOutlined
                        style={{ 
                          marginLeft: 24, 
                          // Allow arrow if field exists and firstInputValue is not null/undefined (including 0, [], and "")
                          cursor: fieldExists && (firstInputValue !== null && firstInputValue !== undefined) ? "pointer" : "not-allowed",
                          color: fieldExists && (firstInputValue !== null && firstInputValue !== undefined) ? "#0A8394" : "#ccc",
                          opacity: fieldExists && (firstInputValue !== null && firstInputValue !== undefined) ? 1 : 0.5
                        }}
                        onClick={() => {
                          // Allow click if field exists and firstInputValue is not null/undefined (including 0, [], and "")
                          if (fieldExists && (firstInputValue !== null && firstInputValue !== undefined)) {
                            let valToSet = firstInputValue;
                            // If firstInputValue is empty string, use original value (which might also be "")
                            if (firstInputValue === "" && value === null) {
                              // If original value is null, don't set anything
                              return;
                            }
                            if (firstInputValue === "" && value === undefined) {
                              // If original value is undefined, don't set anything
                              return;
                            }
                            // Handle object/array values
                            if (isObjectOrArray) {
                              // Handle empty arrays
                              if (Array.isArray(value) && value.length === 0) {
                                valToSet = "[]";
                              } else {
                                valToSet = JSON.stringify(value, null, 2);
                              }
                            } else if (firstInputValue === "" && typeof value === 'string' && value === "") {
                              // If both are empty strings, preserve the empty string
                              valToSet = "";
                            } else if (firstInputValue === "" && value !== null && value !== undefined) {
                              valToSet = String(value);
                            }
                            handleSecondInputChange(String(valToSet));
                          }
                        }}
                      />
                    </div>
                    <div style={{ width: "33%" }}>
                      {isObjectOrArray ? (
                        <TextArea
                          size="small"
                          placeholder={formatFieldName(key)}
                          value={
                            typeof secondInputValue === 'string' 
                              ? secondInputValue 
                              : (Array.isArray(secondInputValue) && secondInputValue.length === 0 
                                  ? "[]" 
                                  : JSON.stringify(secondInputValue, null, 2))
                          }
                          onChange={(e) => handleSecondInputChange(e.target.value)}
                          onBlur={() => validateAllFields()}
                          rows={4}
                          style={{ 
                            fontFamily: "monospace", 
                            fontSize: 12
                          }}
                        />
                      ) : (
                        <Input
                          size="small"
                          placeholder={formatFieldName(key)}
                          value={secondInputValue !== null && secondInputValue !== undefined ? String(secondInputValue) : ""}
                          onChange={(e) => handleSecondInputChange(e.target.value)}
                          onBlur={() => validateAllFields()}
                        />
                      )}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      ),
    },


    {
      key: "4",
      // label: "GST 2B data Matches",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }} ref={sectionRefs["4"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "4")}>
          <div style={{ width: "50%" }}>GST 2B data Matches</div>
          <div style={{ width: "30%" }}>

          </div>
        </div>
      ),
      children: (
        <div >
          <div style={{ width: "100%", marginBottom: 12 }}>
            <Input
              ref={sectionRefs["41"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
              placeholder="Search "
              style={{ width: 300 }}
              onChange={(event) => { setSkipGSTIN(true); fetch2bmatchsElastic(event.target.value) }}
            />
          </div>
          <div style={{ height: 300 }} className="ag-theme-alpine">
            <AgGridReact
              columnDefs={[
                {
                  headerName: "Column No",
                  cellRenderer: (params) => {
                    let sourceId = params.data?._source?.id || params.data?._id;
                    
                    console.log(sourceId, "sourceId")
                    console.log(params.data, "params data")
                    let selectedSourceId =
                      selected2BMatch?._source?.id || selected2BMatch?._id;
                    console.log(selected2BMatch, "selected2BMatch")
                    console.log("PARAMS DATA", params)
                    return (
                      <Checkbox
                        // checked={selectedSourceId === sourceId}
                        onChange={() => setSelected2BMatch(params.data)}
                      />
                    );
                  },
                },
                {
                  headerName: "Trade Name",
                  valueGetter: (params) =>
                    params.data?.["Supplier Trade Name"] 
                },
                {
                  headerName: "Hotel GSTIN",
                  valueGetter: (params) => {
                    return (
                      params.data?.HOTELGSTIN
                      
                    );
                  }
                },
                {
                  headerName: "PAN",
                  valueGetter: (params) => {
                    return (
                    params.data?.PAN
                  )
                }
                },
                {
                  headerName: "Supplier GSTIN",
                  valueGetter: (params) => {
                    return (
                      params.data?.["Supplier GSTIN"]
                    );
                  }
                },
                {
                  headerName: "Document Number",
                  valueGetter: (params) =>
                    params.data?.["Document Number"],
                },
                {
                  headerName: "Document Date",
                  field: "Document Date",
                  valueGetter: (params) =>
                    params.data?.["Document Date"]
                },
                {
                  headerName: "Document Date1",
                  field: "Document Date1",
                  valueGetter: (params) =>
                    params.data?.["Document Date1"]
                },
                {
                  headerName: "CGST",
                  valueGetter: (params) =>
                    params.data?.["CGST Amount"],
                },
                {
                  headerName: "CESS",
                  valueGetter: (params) =>
                    params.data?.["CGST Amount"],
                },
                {
                  headerName: "SGST",
                  valueGetter: (params) =>
                    params.data?.["SGST Amount"],
                },
                {
                  headerName: "IGST",
                  valueGetter: (params) =>
                    params.data?.["IGST Amount"],
                },

                {
                  headerName: "Total Document Value",
                  valueGetter: (params) =>
                    params.data?.["Total Document Value"],
                },
                {
                  headerName: "Total Tax Value",
                  valueGetter: (params) =>
                    params.data?.["Total Tax Value"],
                },
                {
                  headerName: "Total Taxable Value",
                  valueGetter: (params) =>
                    params.data?.["Total Taxable Value"],
                },
                {
                  headerName: "Total GST",
                  valueGetter: (params) =>
                    params.data?.["Total GST"],
                },
              ]}
              rowData={rowData || matchDocument?.two_b_matches || []}
              overlayNoRowsTemplate="No rows to show"
            />
          </div>
        </div>
      ),
    },
    {
      key: "5",
      // label: "Booking details",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }}
        ref={sectionRefs["5"]}
        tabIndex={0}  // Make the section focusable
        onKeyDown={(e) => handleKeyDown(e, "5")}>
          <div style={{ width: "50%" }}>Booking details</div>

        </div>
      ),
      children: (
        <div>
          <div style={{ width: "100%", marginBottom: 12 }}>
            <Input
            ref={sectionRefs["42"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
              placeholder="Search "
              style={{ width: 300 }}
              onChange={(event) => { setSkipGSTIN(true); fetchBookingElasticMatches(event.target.value) }}
              
            />
          </div>
          <div style={{ height: 300 }} className="ag-theme-alpine">
            <AgGridReact
              columnDefs={[
                {
                  headerName : "Column No",
                  cellRenderer: (params) => {
                    let sourceId = params.data?._source?.id || params.data?._id;
                    let selectedSourceId =
                      selectedBookingMatch?._source?.id ||
                      selectedBookingMatch?._id;
                    return (
                      <Checkbox
                        // checked={selectedSourceId === sourceId}
                        onChange={() => setSelectedBookingMatch(params.data)}
                      />
                    );
                  },
                },
                {
                  headerName: "Hotel Name",
                  field: "Hotel Name",
                  valueGetter: (params) =>
                    params.data?.['"Hotel Name"'] ||
                    params.data?._source?.["Hotel Name"],
                },
                {
                  headerName: "Hotel GSTIN",
                  field: "Hotel GSTIN",
                  valueGetter: (params) =>
                    params.data?.["Hotel GSTIN"] ||
                    params.data?._source?.["Hotel GSTIN"],
                },
                {
                  headerName: "Agency Invoice Number",
                  field: "Agency Invoice Number",
                  valueGetter: (params) =>
                    params.data?.["Agency Invoice Number"] ||
                    params.data?._source?.["Agency Invoice Number"],
                },
                {
                  headerName: "Booking Date",
                  field: "Booking Date",
                  valueGetter: (params) =>
                    params.data?.["Booking Date"] ||
                    params.data?._source?.["Booking Date"],
                },
                {
                  headerName: "Total Amount",
                  field: "Total Amount",
                  valueGetter: (params) =>
                    params.data?.["Total Amount"] ||
                    params.data?._source?.["Total Amount"],
                },
              ]}
              rowData={bookingRowData || matchDocument?.booking_matches}
            />
          </div>
        </div>
      ),
    },
  ];
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsNonInvoice(checked);
    if (checked) {
      setSelectedIssue("Not an invoice");
    }
    else {
      setSelectedIssue(null);
    }
  };

  const options = isNonInvoice
    ? [{ value: "Non invoice", label: "Non invoice" }]
    : [
      { value: "E-invoice", label: "E-invoice" },
      { value: "Compliant Tax Invoice", label: "Compliant Tax Invoice" },
      { value: "Informational Invoice", label: "Informational Invoice" },
      { value: "Non-compliant Invoice", label: "Non-compliant Invoice" },
      { value: "Non-compliant Invoice Hence Not Matched", label: "Non-compliant Invoice Hence Not Matched" },
      { value: "Not an invoice", label: "Not an invoice" },
    ];

  console.log(assetLink, "assetLink check")

  return (
    <div className="NewMatchPage">
      <div className="HeaderContainer"></div>
      <div className="MainContentContainer">
        {/* <Modal
        title="Select Priority"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        // footer={[
        //   <Button key="close" type="primary" onClick={() => setIsModalVisible(false)}>
        //     Close
        //   </Button>,
        // ]}
        footer={[
          <Select
          id="priority-select"
          value={selectedPriority}
          onChange={handleSelectChange}
        >
          <Option value="" >
            Select an option
          </Option>
          <Option value="priority1">Priority1</Option>
          <Option value="priority2">Priority2</Option>
          <Option value="priority3">Priority3</Option>
        </Select>
        ]}
     
      >
        <p>Please select a priority before proceeding.</p>
      </Modal> */}

        {/* <div
          className="InvoicePreviewContainer"
        // style={{ width: dimensions.width }}
        >
          <embed
            width="100%"
            height="100%"
            src={matchDocument?.file_details?.invoice_asset_link}
            type="application/pdf"
            id="pdfEmbed"
            style={{
              // display: isLoading ? "none" : "block",
              height: "100%",
              paddingBottom: 20,
            }}
          />
        </div> */}

        <div

          style={{
            width: dimensions.width,
            height: dimensions.height,
            resize: 'both',
            overflow: 'hidden',
            position: 'relative',
            border: '1px solid #ccc',
          }}
          onMouseMove={onResize}
          onMouseUp={stopResizing}
          onMouseLeave={stopResizing}
        >
          <embed
            src={assetLink}

            type="application/pdf"
            width="100%"
            height="100%"
          />
          <div
            onMouseDown={startResizing}
            style={{
              width: '10px',
              height: '10px',
              background: '#ccc',
              position: 'absolute',
              bottom: 0,
              right: 0,
              cursor: 'nwse-resize',
            }}
          />
        </div>
        <div className="DataPreviewContainer">
          {isLoading ? (
            "Loading..."
          ) : (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ width: "120px", display: "flex", justifyContent: "space-between" }}>


                  {/* {selectedPriority && (
                    <span>
                      Selected:{selectedPriority}
                    </span>
                  )} */}
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ width: "400px", display: "flex", alignItems: "center", gap: "12px" }}>
                      <Select
                        style={{ width: 150 }}
                        value={filterType}
                        onChange={(value) => {
                          // Clear all filter-related state
                          setFilterValue("");
                          setCurrentFilterPanNumbers([]);
                          setCurrentFilterGstinNumbers([]);
                          
                          if (value === "All") {
                            // Remove all filters and fetch all documents
                            setFilterType("All");
                            fetchDocument(); // Fetch all documents without any filter
                          } else {
                            // Set new filter type
                            setFilterType(value);
                          }
                        }}
                      >
                        <Option value="All">All</Option>
                        <Option value="client_name">client_name</Option>
                        <Option value="hotel_gstin">hotel_gstin</Option>
                        <Option value="client_gstin">client_gstin</Option>
                      </Select>

                      {filterType === "client_name" && (
                        <Select
                          style={{ width: 200 }}
                          placeholder="Select Client"
                          loading={clientListLoading}
                          value={filterValue}
                          onChange={(value) => {
                            setFilterValue(value);
                            // Call API when client is selected
                            if (value) {
                              // Find the selected client to get PAN numbers
                              const selectedClientData = clientList.find(client => client.client_name === value);
                              const panNumbers = selectedClientData?.pan_numbers || [];
                              setCurrentFilterPanNumbers(panNumbers); // Store PAN numbers for skip functionality
                              // Send client_name and pan_numbers
                              fetchDocument({ 
                                type: filterType, 
                                value: value,
                                pan_numbers: panNumbers
                              });
                            }
                          }}
                          onFocus={() => {
                            // Fetch client list when dropdown is focused/opened
                            if (clientList.length === 0) {
                              fetchClientInfoByPan();
                            }
                          }}
                          showSearch
                          filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                          }
                          options={clientList.map(client => ({
                            label: client.client_name,
                            value: client.client_name,
                          }))}
                        />
                      )}
                      {filterType === "hotel_gstin" && (
                        <Input
                          style={{ width: 200 }}
                          placeholder="Enter hotel GSTIN(s) comma-separated, press Enter"
                          value={filterValue}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterValue(value);
                          }}
                          onPressEnter={(e) => {
                            const value = e.target.value;
                            // Call API only when Enter is pressed
                            if (value.trim()) {
                              setCurrentFilterPanNumbers([]); // Clear PAN numbers for non-client_name filters
                              // Parse comma-separated GSTIN numbers
                              const gstinNumbers = value.split(',').map(gstin => gstin.trim()).filter(gstin => gstin);
                              setCurrentFilterGstinNumbers(gstinNumbers);
                              fetchDocument({ 
                                type: filterType, 
                                value: value.trim(),
                                gstin_numbers: gstinNumbers
                              });
                            }
                          }}
                        />
                      )}
                      {filterType === "client_gstin" && (
                        <Input
                          style={{ width: 200 }}
                          placeholder="Enter client GSTIN(s) comma-separated, press Enter"
                          value={filterValue}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterValue(value);
                          }}
                          onPressEnter={(e) => {
                            const value = e.target.value;
                            // Call API only when Enter is pressed
                            if (value.trim()) {
                              setCurrentFilterPanNumbers([]); // Clear PAN numbers for non-client_name filters
                              // Parse comma-separated GSTIN numbers
                              const gstinNumbers = value.split(',').map(gstin => gstin.trim()).filter(gstin => gstin);
                              setCurrentFilterGstinNumbers(gstinNumbers);
                              fetchDocument({ 
                                type: filterType, 
                                value: value.trim(),
                                gstin_numbers: gstinNumbers
                              });
                            }
                          }}
                        />
                      )}
                    </div>
                  </div>
           

                </div>

                <div className="PaginationContainer">

                  {/* <Button
                    color="default"
                    variant="outlined"
                    icon={<ArrowLeftOutlined />}
                    onClick={handleLeftArrowClick}
                  ></Button> */}
                  <Button color="default" variant="outlined">
                    {currenntDoc} of {totalCount}
                  </Button>
                  <Button
                    color="default"
                    variant="outlined"
                    icon={<ArrowRightOutlined />}
                    onClick={handleSkipDocument}
                  ></Button>
                </div>
                {/* <div className="StatsContainer">
                <div>Invoices: 9,999</div>
                <div>MATCHED: 999</div>

                <div>Pending: 9,000</div>
              </div> */}
              </div>

              <div className="DataCollectionContainer"


              >
                <Checkbox checked={isNonInvoice} onChange={handleCheckboxChange}>
                  Non-invoice
                </Checkbox>
                <Collapse items={items} defaultActiveKey={["1", "2", "3"]} onChange={handleCollapseChange} />
              </div>
              <div className="MatchResultContainer">
                <div className="IssueSelectionContainer">
                  <Select
                    style={{
                      width: "100%",
                    }}
                    // onChange={(item) => setSelectedIssue(item)}
                    onChange={(item) => {
                      setSelectedIssue(item);
                      setIsNonInvoice(item === "Not an invoice"); // Sync checkbox if issue changes via Select
                    }}
                    placeholder="Choose the issue"
                    value={selectedIssue}
                    // options={[
                    //   { value: "E-invoice", label: "E-invoice" },
                    //   {
                    //     value: "Compliant Tax Invoice",
                    //     label: "Compliant Tax Invoice",
                    //   },
                    //   {
                    //     value: "Informational Invoice",
                    //     label: "Informational Invoice",
                    //   },
                    //   {
                    //     value: "Non-compliant Invoice",
                    //     label: "Non-compliant Invoice",
                    //   },
                    //   {
                    //     value: "Non-compliant Invoice Hence Not Matched",
                    //     label: "Non-compliant Invoice Hence Not Matched",
                    //   },
                    //   { value: "Not an invoice", label: "Not an invoice" }

                    // ]}

                    options={options}



                  />
                </div>
                <div className="RemarksContainer">
                  <TextArea
                    rows={4}
                    placeholder="Add your remarks"
                    onChange={(event) => setRemarks(event.target.value)}
                    value={remarks}
                  />
                </div>
              </div>
              <div className="ActionContainer">
                <Button
                  icon={<DoubleRightOutlined />}
                  onClick={handleSkipDocument}
                >
                  Skip
                </Button>

                <Button
                  type="primary"
                  style={{ marginLeft: 18 }}
                  onClick={handleSaveCollection}
                  disabled={isSaveDisabled}
                >
                  Save
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
      <Drawer
        title="Add GSTIN"
        placement="right"
        onClose={closeDrawer} // Close the Drawer
        open={isDrawerOpen} // Control visibility with state
        width={600} // Set the width of the Drawer
      >
        {/* Render the AddGSTIN component inside the Drawer */}
        <NewGstinPage clientGSTIN={clientGSTIN} />
      </Drawer>
      {contextHolder}
    </div>
  );
}